export default __webpack_public_path__ + "static/28-4f7bcc95c9f0df36ade50e136a9464b6.jpg";